module.exports = __webpack_public_path__ + "static/scale-model-of-fort-lauderdale-florida-336a9b581c5fc316681f22809a5b7ae4.png";